module.exports = __webpack_public_path__ + "static/media/graham.3cd421a2.jpg";